import React from "react";
import { Link } from "react-router-dom";

const Copyright = () => {
  return (
    <>
      <footer className="bg-body-tertiary py-3 px-3 text-center position-fixed bottom-0 w-100">
        All Rights Reserved &copy; Swalok Group Developed by{" "}
        <Link
          to="https://dectwinservices.com"
          target="_blank"
          className="text-dark text-decoration-none"
        >
          Dectwin Services Pvt Ltd
        </Link>
      </footer>
    </>
  );
};

export default Copyright;
